__turbopack_context__.v({
  "footer": "footer-module-scss-module__iCIeZG__footer",
  "inner": "footer-module-scss-module__iCIeZG__inner",
  "logo": "footer-module-scss-module__iCIeZG__logo",
});
